import { usePrevious } from 'astra-core/hooks/usePrevious'
import { EFeatureFlags } from 'astra-core/containers/ConfigProvider/types'
import { ENV, getEnv } from 'astra-core/utils/env'
import { selectBroadcastAvailabilityByEventId } from 'astra-core/containers/BroadcastProvider/selectors'
import { useCallback, useEffect } from 'react'
import { broadcastProviderActions } from 'astra-core/containers/BroadcastProvider/slice'
import { selectAccount } from 'astra-core/containers/AccountProvider/selectors'
import { selectIsDevelopment } from 'astra-core/containers/ConfigProvider/selectors'
import { BroadcastType } from 'betweb-openapi-axios/dist/api'

import { matchBroadcastModel } from 'entities/match-broadcast'
import { useAppDispatch, useAppSelector } from 'store'
import { useInterval } from 'hooks'
import { useAppFeatureFlag } from 'shared/config'

import { BROADCAST_POLLING_INTERVAL } from '../constants'
import { getRedirectUrl } from '../utils'

export const useFetchBroadcast = () => {
  const currentBroadcastEvent = useAppSelector(
    matchBroadcastModel.selectCurrentBroadcast
  )
  const dispatch = useAppDispatch()
  const isDevelopment = useAppSelector(selectIsDevelopment)
  const isLogged = !!useAppSelector(selectAccount)
  const prevLogged = usePrevious(isLogged)

  const isBroadcastFeatureFlagEnabled = useAppFeatureFlag(
    EFeatureFlags.BROADCAST_ENABLED
  )
  const env = getEnv()
  const broadcastEnabled =
    currentBroadcastEvent &&
    isBroadcastFeatureFlagEnabled &&
    [ENV.STAGE, ENV.PROD].includes(env)

  const hasBroadcast = useAppSelector((state) => {
    if (!currentBroadcastEvent) return false
    return selectBroadcastAvailabilityByEventId(state, currentBroadcastEvent)
  })
  const prevHasBroadcast = usePrevious(hasBroadcast)

  const fetchEventBroadcast = useCallback(() => {
    if (broadcastEnabled && hasBroadcast && isLogged) {
      dispatch(
        broadcastProviderActions.fetchBroadcast({
          reqData: {
            eventId: currentBroadcastEvent,
            preferredBroadcastType: BroadcastType.Hls,
            redirectUrl: getRedirectUrl(isDevelopment)
          }
        })
      )
    }
  }, [
    dispatch,
    isDevelopment,
    hasBroadcast,
    broadcastEnabled,
    isLogged,
    currentBroadcastEvent
  ])

  useEffect(() => {
    if (!prevHasBroadcast && hasBroadcast) {
      fetchEventBroadcast()
    } else if (!prevLogged && isLogged) {
      fetchEventBroadcast()
    }
  }, [
    prevHasBroadcast,
    hasBroadcast,
    fetchEventBroadcast,
    prevLogged,
    isLogged
  ])

  useInterval(fetchEventBroadcast, BROADCAST_POLLING_INTERVAL, true)
}
